<template lang="pug">
  .SampleGeographicInfo(:class="{'SampleGeographicInfo_is-open': classOpened }")#SampleGeographicInfo

    .SampleGeographicInfo_container
      p.SampleGeographicInfo_title {{ name }}
      p.SampleGeographicInfo_class(v-if="parent") {{ $t('sample.geologic_belongs', { parent: parent }) }}
      ButtonSimple(@click.native="classToggle" class="ButtonSimple_black" :class="{'hover': classOpened }", v-if="withButton") {{ $t('sample.geologic_discover') }}

      .SampleGeographicInfo_close.Cta_round(@click="classToggle(false)", v-if="withButton")
        SvgInline(src="cross-beige")

    SampleGeographicDetails(:geologicType="geologicType" :type="type" v-if="classOpened && withButton")

</template>

<script>

import SvgInline from '@/components/SvgInline'
import ButtonSimple from '@/components/common/ButtonSimple'
import SampleGeographicDetails from '@/components/SampleGeographicDetails'
import { TweenLite, Power4 } from 'gsap'

export default {
  props: ['geologicType', 'type', 'parent', 'openState', 'withButton'],
  components: { SampleGeographicDetails, ButtonSimple, SvgInline },
  data () {
    return {
      classOpened: this.openState,
      scrollto: '#SampleGeographicDetails'
    }
  },
  computed: {
    name () {
      return Array.isArray(this.geologicType) ? this.geologicType.map((g) => g.name).join(', ') : this.geologicType.name
    }
  },
  methods: {
    classToggle (state = true) {
      const closeH = (document.body.querySelector('.CoverSectionContent').offsetHeight + document.body.querySelector('.SampleGeographicInfo_container').offsetHeight) - window.innerHeight

      if (!state) {
        document.body.querySelector('.MainContainer').scrollTop = closeH
      }

      this.classOpened = !this.classOpened
    }
  },
  mounted () {

  }
}

</script>

<style lang="stylus" scoped>

.SampleGeographicInfo
  position relative
  z-index: 2;

  &_container

    position relative
    padding 110px 20px
    background-color $beige
    background-image url('/img/backgrounds/key-figures_background.jpg')
    background-size cover
    background-position center
    overflow hidden
    text-align center

    &:before

      content ''
      position absolute
      bottom -15px
      height 15px
      background-color #807867
      left 0px
      width 100%
      z-index 0
      opacity 0
      transform translateY(-100%)
      transition all 1s $ease

  &_close

    position absolute
    z-index 2
    left 50%
    transform translateX(-50%) scale(0.3)
    opacity 0
    bottom -25px
    transition all 0.4s $ease
    height 50px
    width 50px
    cursor pointer
    border 1px solid $beige
    border-radius 50%
    background black
    box-sizing border-box
    display flex
    flex-direction column

    svg

      width 20px!important
      height 20px
      margin auto

  &_is-open

    .SampleGeographicInfo_container
      overflow visible

      &:before

        transform translateY(0%)
        opacity 1

    .SampleGeographicInfo_close

      transform translateX(-50%) scale(1)
      opacity 1

  &_title

    font-family: 'Sectra Display'
    font-size: 50px;
    letter-spacing: 2px;
    line-height 1em

    @media $mq_s_only

      hyphens auto
      font-size 31px

  &_class

    margin-top 15px

  .ButtonSimple_black

    margin-top 40px

</style>
